import Cookies from 'js-cookie'
const TokenKey = 'task-Token'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const urlInfoKey = 'urlInfo'
export function getUrlInfo() {
  return Cookies.get(urlInfoKey)
}

export function setUrlInfo(token) {
  return Cookies.set(urlInfoKey, token)
}

export function setSession(key, value) {
  value = JSON.stringify(value)
  sessionStorage.setItem(key, value)
}

export function getSession(key) {
  if (key === '') return ''
  const retValue = sessionStorage.getItem(key)
  if (retValue == null) return ''
  return retValue
}

export function delSesssion(key) {
  if (key) {
    sessionStorage.removeItem(key)
  }
}

// 权限系统完整token，用于处理通过链接进入系统页面时，sessionStorage中没有userInfo信息
const powerToken = window.location.host

export function getTokenPower() {
  return Cookies.get(powerToken)
}

export function setTokenPower(token) {
  const inHalfADay = 0.5 // 12小时失效时间
  return Cookies.set(powerToken, token, {
    expires: inHalfADay
  })
}

export function removeTokenPower() {
  return Cookies.remove(powerToken)
}

const domainStr = process.env.NODE_ENV === 'production' ? '.suntekcorps.com' : '.sfccorps.com'
export function getPowerSystemCookie() {
  return Cookies.get('Power-Admin-Info', { domain: domainStr })
}